import { Button, DataGrid } from 'devextreme-react';
import { Column, FilterRow, Pager, Paging, Scrolling, Summary, TotalItem } from 'devextreme-react/data-grid';
import React, { useRef, } from 'react';
import { FormatNumber, ConvertDateFormat, ConvertDateTimeFormat } from '../../common';
import './call-service-search.scss';
import "react-datepicker/dist/react-datepicker.css";
import DateBox from 'devextreme-react/date-box';
import { ExcelExport } from '../../common/excel';

import { locale } from 'devextreme/localization';
locale('ko'); // DateBox 한글 사용

const CallServiceSearchV2 = ({ callServiceSearch, onValueChanged, useInfo, onClickSearch }) => {
  
  const refDataGid = useRef(null);

  return (
    <React.Fragment>
      <div className="call-bill-list">
        <h2 className="main-title">콜 내역 조회</h2>
        <div className="call-list-use-info-top">
          <div className="call-list-use-info-top-label">기간 : </div>
          <div className="call-list-use-info-top-value">
            <DateBox
              type="date"
              defaultValue={new Date()}
              width={90}
              value={useInfo.FromDate}
              displayFormat="yyyy-MM-dd"
              stylingMode='outlined'
              onValueChanged={(e) => onValueChanged('FromDate', e)}
              openOnFieldClick={true}
              acceptCustomValue={false}
              style={{ backgroundColor: 'white', height: '30px' }}
            />
          </div>
          <div className="call-list-use-info-top-label-wave">~</div>
          <div className="call-list-use-info-top-value">
            <DateBox
              type="date"
              defaultValue={new Date()}
              width={90}
              value={useInfo.ToDate}
              displayFormat="yyyy-MM-dd"
              stylingMode='outlined'
              onValueChanged={(e) => onValueChanged('ToDate', e)}
              openOnFieldClick={true}
              acceptCustomValue={false}
              style={{ backgroundColor: 'white', height: '30px' }}
            />
          </div>
          <div className="call-list-top-label-amount-search">
            <Button
                className="Btn"
                stylingMode="contained"
                type="default"
                text="조회"
                onClick={onClickSearch}
            />
          </div>
          <div className="call-list-top-label-amount-excel">
            <Button
                className="Btn"
                stylingMode="contained"
                type="success"
                text="엑셀"
                onClick={() =>
                  ExcelExport(
                    refDataGid.current.instance,
                    (useInfo.FromDate === useInfo.ToDate ? useInfo.ToDate : useInfo.FromDate + '~' + useInfo.ToDate) + ' 이용내역.xlsx'
                  )
                }
              />  
            </div>
        </div>
        <div className="grid">
          <DataGrid
            className="grid100"
            columnAutoWidth={false}
            allowColumnResizing={true}
            dataSource={callServiceSearch}
            keyExpr="Seq"
            noDataText="콜내역이 없습니다."
            showBorders={false}
            rowAlternationEnabled= {true} // 짝수 row 색상
            showColumnLines={true} // column 구분선
            ref={refDataGid}
            wordWrapEnabled={true}
          >
            <Scrolling rowRenderingMode="virtual" />
            <Column 
              dataField="RequestDateTime" 
              caption="접수시간" 
              alignment="center" 
              width="70"
              customizeText={(e) => ConvertDateTimeFormat(e.value)}
            />
            {/* <Column 
              dataField="AppDate" 
              caption="접수일자" 
              alignment="center" 
              width="100"
              customizeText={(e) => ConvertDateFormat(e.value)}
            />
            <Column
              dataField="Seq"
              caption="접수번호"
              alignment="center"
              width="100"
            /> */}
            <Column
              dataField="StartDong"
              caption="출도착"
              alignment="center"
              width="150"
            />
            {/* <Column
              dataField="PassThrough"
              caption="경유지"
              alignment="center"
              width={200}
            />
            <Column
              dataField="EndDong"
              caption="도착동"
              alignment="center"
              width={400}
            /> */}
            <Column 
              dataField="Charge" 
              caption="요금" 
              alignment="center" 
              width="70"
              customizeText={(e) => FormatNumber(e.value) + '원'}
              />
            <Column
              dataField="DriverName"
              caption="기사명"
              alignment="center"
              width="60"
            />
            {/* <Column 
              dataField="AllocationDateTime" 
              caption="배차시간" 
              alignment="center" 
              width="100"
              customizeText={(e) => ConvertDateTimeFormat(e.value)}
            />
            <Column 
              dataField="CompleteDateTime" 
              caption="완료시간" 
              alignment="center" 
              width="100"
              customizeText={(e) => ConvertDateTimeFormat(e.value)}
            /> */}
            <Paging defaultPageSize={15} enabled={true} />
            <Pager showPageSizeSelector={false} showInfo={false} />
            <Summary>
                  <TotalItem
                      column="RequestDateTime"
                      summaryType="count"
                      displayFormat={(value) => '총 : ' + new Intl.NumberFormat('ko').format(value) + '건'}
                  />
                  <TotalItem
                      column="Charge"
                      summaryType="sum"
                      displayFormat={(value) => new Intl.NumberFormat('ko').format(value) + '원'}
                  />
              </Summary>
          </DataGrid>
        </div>
      </div>
    </React.Fragment>
  );
};

export default React.memo(CallServiceSearchV2);
